<template><span>
    <label>Attached AP File</label><br />
    <a :href="auditFileExportUrl" target="_blank">{{apFile.AuditFileNumber}}</a>
    <ed-button
      button-class="btn btn-actionbar-primary pull-right"
      @click="show = true"
      name='replace-ap-file-btn'
      >{{ 'Replace' }}</ed-button>
    <br />
    
    <ed-modal
      :show="show"
      title="Replace AP File"
      primary-button="Replace"
      secondary-button="Cancel"
      type="medium"
      @close="onClose"
      @validate="onSave"
      :validation="true"
      :closeOnEsc="true"
      name='replace_ap_file'
    >
      <div slot="body">
        <section class="col-md-6 no-pad">
          <label>AP File</label>
          <p>{{apFile.AuditFileNumber}}</p>

          <ed-upload
              :class='{loading: !uploadFinished}'
              field-label='Attachment'
              button-label='Upload File'
              v-model='attachmentFiles'
              readonly
              :multiple='false'
              :postAction='api.env + api.$.upload.uploadFile'
              :uploadAuto='true'
              :data='uploadSettings'
              required
              @input='createAttachments'
              :showHelptipIcon='false'
              helptipHeader=''
              :error='attachmentMissingError'
              :helptip-body='attachmentMissingError && "Please attach a file." || ""'
              name='attachment_upload'
            ></ed-upload>
            
          <ed-textarea
            v-model="paymentNotes"
            field-label="Payment Notes"
            :required='false'
            :maxLength='150'
            name='ap_file_notes'
          />
        </section>
        <ed-modal
          :show='displayUploadError'
          @close='displayUploadError = false'
          title=''
          primaryButton='false'
          secondaryButton='Ok'
          type='medium'
          name='replace_ap_file_upload_error'
        >
          <div slot="body">
            <p>{{uploadError}}</p>
          </div>
        </ed-modal>
        <div class="clear"></div>
      </div>
    </ed-modal>
  </span>
</template>

<script>
/* eslint spec-file: 0 */

import Grid from '@/components/Grid'

export default {
  name: 'ReplaceApFile' /* mandatory field */,

  components: {
    Grid
  },

  props: {
    apFile: Object,
    token: String
  },

  activated() {
    this.show = false
    this.attachmentFile = ''
    this.displayUploadError = false
    this.uploadError = ''
  },

  data() {
    return {
      show: false,
      paymentNotes: '',
      uploadFinished: true,
      attachmentFile: '',
      attachmentFiles: null,
      attachmentMissingError: false,
      displayUploadError: false,
      uploadError: ''
    }
  },

  computed: {
    auditFileExportUrl() {
      return this.api.env + this.api.$.payment.generateApFile + '?auditFileId=' + this.apFile.ApFileId
    },

    uploadSettings() {
      return {
        folder: 'Temp/',
        token: this.token,
        fileType: 'excel/csv',
        renameFile: this.apFile.AuditFileNumber
      }
    }
  },

  methods: {
    onClose() {
      this.show = false
      this.attachmentFiles = []
    },

    isValid() {
      let valid = this.attachmentFiles && this.attachmentFiles.length > 0
      this.attachmentMissingError = !valid

      return valid
    },

    onSave() {
      if (!this.isValid()) return

      this.doReplace()
    },

    doReplace() {
      this.api
        .post(this.api.$.payment.replaceApFile, {
          auditFileID: this.apFile.ApFileId,
          uploadedFile: this.apFile.AuditFileNumber + '.' + this.getFileExtension(this.attachmentFiles[0].name),
          additionalNote: this.paymentNotes
        })
        .then(response => {
          // TODO: validate response
          this.onClose()
        })
    },

    getFileExtension(fileName) {
      if (/[.]/.exec(fileName)) {
        let ext = /[^.]+$/.exec(fileName)
        if (ext && ext.length > 0) {
          return ext[0]
        }
      }
      return 'xls'
    },

    createAttachments(e) {
      let completedFiles = e.filter(
        item => item.success || // files uploaded with success
        (!item.success && item.response && typeof item.response === 'string' && !this.isJson(item.response)) // files where requested failed
      )
      if (completedFiles.length >= 1) {
        this.attachmentMissingError = false
      }
      if (completedFiles.length === e.length) {
        this.uploadFinished = true
        e.map(item => {
          let itemResponse = null

          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response)
            this.uploadError = (itemResponse && itemResponse.uploadError) ? itemResponse.uploadError : ''
          }
          if (!item.success) {
            this.uploadError = 'Upload request failed'
          }
        })
        if (this.uploadError !== '') {
          this.displayUploadError = true
        }
        this.attachmentFiles = e.filter(item =>
          item.success &&
          JSON.parse(item.response).success)
      } else {
        this.uploadFinished = false
      }
    },
    isJson(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.form-group {
  section.pad {
    padding-left: 15px;
  }

  >>> .form-control {
    &.form-control {
      font-size: $font-size-base-sm;
    }
  }
}

.no-pad {
  padding: 0;
  margin: 0;
}

.heading {
  &.right-label {
    text-align: right;
    padding-right: 27px;
  }
  label {
    font-weight: $font-weight-extra-bold;
  }
}

.bold-text {
  font-weight: $font-weight-bold;
}

b {
  line-height: 2em;
}

.section-title {
  @include soft-font;
  font-size: $font-size-base-lg;
  font-weight: $font-weight-normal;
  @include theme {
    color: v(border);
  }
  margin-bottom: 7px;

  .icon {
    @include theme {
      color: v(ink);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/components/ReplaceApFile.vue